module.exports = new __parcel__URL__("cegLogoWithName.23444fd8.png").toString();